import { NgModule } from '@angular/core';
import { UserImageRendererComponent } from './user-image-renderer/user-image-renderer.component';

/**
 * FTK-7242 Phase 5b: the three AG-only `IFilterAngularComp` filters (dropdown / search / select) were
 * deleted with the AG Grid engine. Their behaviour lives on in the TanStack filter controls under
 * `common/components/data-table/filters/` — the predicates there (`passesSearch`, `passesDropdown`,
 * `passesSelect`) were ported from those very files, so the matching semantics are preserved.
 *
 * UserImageRenderer stays: it is a standalone cell component that `<ft-data-table>` mounts via
 * ngComponentOutlet, and it is still named by live dashboard column definitions.
 */
@NgModule({
    imports: [UserImageRendererComponent],
    exports: [UserImageRendererComponent],
})
export class CommonGridModule { }
